import axios from "axios";
import {
  GET_ALL_PROPERTIES_REQUEST,
  GET_ALL_PROPERTIES_REQUEST_CHAT,
  GET_PROPERTY_REQUEST_DETAILS,
} from "../actions";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const PROXY = process.env.REACT_APP_URL + "api/";

export const getPropertyRequest =
  (page, limit, search, type) => async (dispatch) => {
    const res = await axios.get(
      `${PROXY}admin/property/request/all?page=${page}&limit=${limit}&search=${search}&propertyType=${type}`
    );
    dispatch({
      type: GET_ALL_PROPERTIES_REQUEST,
      payload: res.data.result,
    });
    return res.data.result;
  };

export const getPropertyRequestNotification = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}notification/property-request`);

  return res.data.result;
};

export const getPropertyRequestDetail = (id, request) => async (dispatch) => {
  const res = await axios.get(`${PROXY}admin/property/request/detail/${id}`);
  dispatch({
    type: GET_PROPERTY_REQUEST_DETAILS,
    payload: res.data.result,
  });
  return res.data.result;
};

export const propertyRequestChangeStatus = (id, data) => async (dispatch) => {
  const res = await axios.put(
    `${PROXY}admin/property/approve/reject/${id}`,
    data
  );
  return res;
};

export const getPropertyRequestChat = (id) => async (dispatch) => {
  const res = await axios.get(`${PROXY}admin/property-request-chat/${id}`);
  dispatch({
    type: GET_ALL_PROPERTIES_REQUEST_CHAT,
    payload: res.data.result,
  });
  return res;
};

export const sendPropertyRequestMesage = (data) => async (dispatch) => {
  const body = JSON.stringify(data);
  const res = await axios.post(
    `${PROXY}admin/property-request-chat/send`,
    body,
    config
  );
  return res;
};
